import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { createNewOmitHttpErrorCodesContext } from '@shared/constants/OMIT_HTTP_ERROR_CODES_HTTP_CONTEXT';
import { retry, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CookiesInitService {
  constructor(private _httpClient: HttpClient) {
    this._initCookies();
  }

  private _initCookies() {
    return this._httpClient
      .get('hello', {
        responseType: 'text',
        context: createNewOmitHttpErrorCodesContext([403, 504, 502, 404, 0]),
      })
      .pipe(
        retry({
          delay: () => timer(3000),
        })
      )
      .subscribe();
  }
}
